import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_a7fece3c-1098-4c53-90c7-eb2ad84e0289/artifacts/3fhcfvy9_E3CF7E4A-7542-40DF-B885-36DE8AD0C900.PNG)',
          filter: 'brightness(1)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A2846]/70 via-[#0A2846]/65 to-[#0A2846]/70" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className={`transition-all duration-1200 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-[#E8EEF3] mb-6 sm:mb-8 lg:mb-10 leading-tight tracking-tight px-2">
            Professionelle Gebäudereinigung.
            <br />
            <span 
              className="gold-shine block mt-2 sm:mt-3 lg:mt-4"
              style={{
                background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
                backgroundSize: '200% auto',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Zuverlässig. Transparent. Werteorientiert.
            </span>
          </h1>
          
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-[#E8EEF3]/95 mb-8 sm:mb-10 lg:mb-14 max-w-4xl mx-auto leading-relaxed font-light px-4">
            Ihr Partner für Gewerbe, Büros und Wohnimmobilien.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center px-4">
            <Button
              onClick={() => navigate('/kontakt')}
              className="w-full sm:w-auto font-semibold text-base sm:text-lg px-8 sm:px-12 py-6 sm:py-8 transition-all duration-500 hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
                color: '#0A2846',
                boxShadow: '0 10px 40px rgba(212, 175, 55, 0.5), 0 0 50px rgba(212, 175, 55, 0.3)'
              }}
            >
              Kostenloses Angebot anfordern
            </Button>
            <Button
              variant="outline"
              className="w-full sm:w-auto border-2 border-[#E8EEF3] text-[#E8EEF3] hover:bg-[#E8EEF3] hover:text-[#0A2846] font-semibold text-base sm:text-lg px-8 sm:px-12 py-6 sm:py-8 transition-all duration-500 backdrop-blur-sm bg-white/5"
              onClick={() => window.location.href = 'tel:+491701247477'}
            >
              Jetzt anrufen
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce opacity-60">
        <div className="w-6 h-10 border-2 border-[#E8EEF3]/50 rounded-full flex items-start justify-center p-2">
          <div 
            className="w-1.5 h-3 rounded-full"
            style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)' }}
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;